import api from './api';
import type {
  ExploreAccess,
  ExploreCreatorDetail,
  ExploreSearchParams,
  ExploreSearchResponse,
} from '../types/explore';

/**
 * Client for `/api/explore` — the shared creator pool.
 *
 * Every read here is metered against the agency's quota on the server, so the UI should ask once
 * per interaction and let React Query cache the answer rather than refetching on every render.
 */

export async function getExploreAccess(): Promise<ExploreAccess> {
  const res = await api.get<ExploreAccess>('/explore/access');
  return res.data;
}

export async function joinCreatorPool(): Promise<ExploreAccess> {
  const res = await api.post<ExploreAccess>('/explore/opt-in', { acceptTerms: true });
  return res.data;
}

export async function leaveCreatorPool(): Promise<ExploreAccess> {
  const res = await api.post<ExploreAccess>('/explore/opt-out', {});
  return res.data;
}

export async function searchPoolCreators(
  params: ExploreSearchParams
): Promise<ExploreSearchResponse> {
  const res = await api.get<ExploreSearchResponse>('/explore/creators', { params });
  return res.data;
}

export async function getPoolCreator(id: string): Promise<ExploreCreatorDetail> {
  const res = await api.get<ExploreCreatorDetail>(`/explore/creators/${id}`);
  return res.data;
}

export async function adoptPoolCreator(
  id: string
): Promise<{ outcome: 'created' | 'already_in_roster'; kolProfileId: string | null }> {
  const res = await api.post<{ outcome: 'created' | 'already_in_roster'; kolProfileId: string | null }>(
    `/explore/creators/${id}/adopt`,
    {}
  );
  return res.data;
}
